<template>
  <b-form-group
      label="Kategori"
      label-for="id_service_categories"
  >
    <validation-provider
        #default="{ errors }"
        name="Başlık"
        rules="required"
    >
    <v-select
        id="id_service_categories"
        v-model="dataItem.id_service_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
    >
      <template v-slot:option="option">
        <div>
          {{ option.title }}
        </div>
        <div>
          <small class="text-warning">{{ option.main_category }}</small>
        </div>
      </template>
    </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>

</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'

import vSelect from 'vue-select'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Title',
  components: {
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    dataList() {
      return this.$store.getters['serviceCategories/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('serviceCategories/getDataList', {
        select: [
          'service_categories.id AS id',
          'service_categories.title AS title',
          'service_categories.content AS content',
          'sc.title AS main_category',
        ],
        where: {
          'service_categories.id_service_categories': null,
        },
      })
    },
  },
}
</script>
